import { HTMLProps } from "react";

import { Icon } from "components/icon/Icon";

import "./Input.scss";

type InputProps = Omit<HTMLProps<HTMLInputElement>, "size" | "onChange"> & {
  variant?: "rounded" | "normal";
  size?: "sm" | "md" | "lg" | "slim";
  hasSearchIcon?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export function Input({
  variant = "normal",
  className = "",
  size = "md",
  hasSearchIcon = false,
  ...rest
}: InputProps) {
  const v = variant || "";
  const c = `input ${className}`;
  const s = size || "";

  return hasSearchIcon ? (
    <div className="input-container">
      <input className={`${c} ${s} ${v}`} {...rest} />
      <span className="input-icon">
        <Icon name="search" />
      </span>
    </div>
  ) : (
    <input className={`${c} ${s} ${v}`} {...rest} />
  );
}

type LabelProps = HTMLProps<HTMLLabelElement> & object;

export function Label({ children, ...rest }: LabelProps) {
  return (
    <label className={"label"} {...rest}>
      {children}
    </label>
  );
}
